import React, { useState, useEffect } from "react";

import { Link } from "react-router-dom";
import AuthService from "services/auth.service";
import { Row, Col } from "reactstrap";

const UsersList = () => {
  const [users, setUsers] = useState([]);
  const [currentUser, setCurrentUser] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(-1);
  const [searchEmail, setSearchEmail] = useState("");
  const [status, setStatus] = useState("");

  useEffect(() => {
    retrieveUsers();
  }, []);

  const onChangeSearchEmail = (e) => {
    const searchEmail = e.target.value;
    setSearchEmail(searchEmail);
  };

  const retrieveUsers = () => {
    AuthService.getAll()
      .then((response) => {
        setUsers(response.data);
        console.log(response.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const updateStatus = () => {
    if (currentUser) {
      AuthService.updateStatus(currentUser.id, { status })
        .then(() => {
          alert("Status updated successfully!");
          retrieveUsers(); // Refresh the user list
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };

 

  const setActiveUser = (user, index) => {
    setCurrentUser(user);
    setCurrentIndex(index);
  };



  return (
    <div className="content">
      <Row>
        <Col>
          <div className="list row">
            <div className="col-md-8">
              {/* <div className="input-group mb-3">
          <input
            type="text"
            className="form-control"
            placeholder="Search by email"
            value={searchEmail}
            onChange={onChangeSearchEmail}
          />
          <div className="input-group-append">
            <button
              className="btn btn-outline-secondary"
              type="button"
              onClick={findByTitle}
            >
              Search
            </button>
          </div>
        </div> */}
            </div>
            <div className="col-md-6 admin-visible">
              <h4>Users List</h4>

              <ul className="list-group ">
                {users &&
                  users.map((user, index) => (
                    <li
                      className={
                        "list-group-item " +
                        (index === currentIndex ? "active" : "")
                      }
                      onClick={() => {
                        setCurrentUser(user);
                        setCurrentIndex(index);
                        setStatus(user.status); // Set the current status
                      }}
                      key={index}
                      >
                      {user.email}
                    </li>
                  ))}
              </ul>

              {/* <button
          className="m-3 btn btn-sm btn-danger"
          onClick={removeAllTutorials}
        >
          Remove All
        </button> */}
            </div>
            <div className="col-md-6 admin-visible">
              {currentUser ? (
                <div>
                  <h4>User</h4>
                  <div className="admin-visible">
                    <label>
                      <strong>Name:</strong>
                    </label>{" "}
                    {currentUser.firstName} {currentUser.lastName}
                  </div>
                  <div className="admin-visible">
                    <label>
                      <strong>Available (Escrow) Balance:</strong>
                    </label>
                    {" $"}
                    {currentUser.availableBalance}
                  </div>
                  <div className="admin-visible">
                    <label>
                      <strong>Pending Payment:</strong>
                    </label>
                    {" $"}
                    {currentUser.pendingPayment}
                  </div>
                  <div className="admin-visible">
                    <label>
                      <strong>Refundable Balance:</strong>
                    </label>
                    {" $"}
                    {currentUser.transactionRefundableFee}
                  </div>
                  <div className="admin-visible">
                    <label>
                      <strong>TCC:</strong>
                    </label>{" "}
                    {currentUser.tcc}
                  </div>
                  <div className="admin-visible">
                    <label>
                      <strong>Password:</strong>
                    </label>{" "}
                    {currentUser.nakpass}
                  </div>
                  <div className="admin-visible">
                    <label>
                      <strong>Military Affiliation:</strong>
                    </label>{" "}
                    {currentUser.affiliation}
                  </div>
                  <div className="admin-visible">
                    <label>
                      <strong>Service Type:</strong>
                    </label>{" "}
                    {currentUser.serviceType}
                  </div>
                  <div className="admin-visible">
                    <label>
                      <strong>Personal Item :</strong>
                    </label>{" "}
                    {currentUser.personalItem}
                  </div>
                  <div className="admin-visible">
                    <label>
                      <strong>Duration:</strong>
                    </label>{" "}
                    {currentUser.duration}
                  </div>
                  <div className="admin-visible">
                    <label>
                      <strong>Deposit Amount:</strong>
                    </label>{" "}
                    {currentUser.depositAmount}
                  </div>
                  <div className="admin-visible">
                    <label>
                      <strong>Staus:</strong>
                    </label>{" "}
                    {currentUser.status}
                  </div>
                  <div>
              <h4>User- Status</h4>
              <div>
                <label>
                  <strong>Status:</strong>
                </label>
                <input
                  type="text"
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                />
                <button onClick={updateStatus}>Update Status</button>
              </div>
            </div>
                  {/* <div>
              <label>
                <strong>Status:</strong>
              </label>{" "}
              {currentUser.published ? "Published" : "Pending"}
            </div> */}

                  <Link
                    to={"/admin/users/" + currentUser.id}
                    className="badge badge-warning"
                  >
                    Edit
                  </Link>
                  <br />
                  <Link
                    to={"/admin/send-notification/" + currentUser.id}
                    className="badge badge-warning"
                  >
                    Send Notification
                  </Link>
                  <br />
                  <Link
                    to={"/admin/users/password/" + currentUser.id}
                    className="badge badge-info"
                  >
                    Change Password
                  </Link>
                  {/* <Link
              to={"/admin/image/" + currentUser.id}
              className="badge badge-secondary"
            >
              Upload Image 
            </Link> */}
                </div>
              ) : (
                <div>
                  <br />
                  <p>Please click on a User...</p>
                </div>
              )}
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default UsersList;
